import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import PipelinePanel from '@/components/Apps/ParserAdmin/PipelinePanel.vue'
import ChunksPanel from '@/components/Apps/ParserAdmin/ChunksPanel.vue'
import StatsPanel from '@/components/Apps/ParserAdmin/StatsPanel.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ParserAdminPage',
  setup(__props) {

const tab = ref('pipeline')

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex align-center justify-space-between mb-5" }, [
      _createElementVNode("h4", { class: "mb-0" }, "Parser Yönetimi")
    ], -1)),
    _createVNode(_component_v_tabs, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
      color: "primary",
      class: "mb-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "pipeline" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Pipeline", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "chunks" }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("Chunk Yönetimi", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "stats" }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("İstatistikler", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "pipeline" }, {
          default: _withCtx(() => [
            _createVNode(PipelinePanel)
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "chunks" }, {
          default: _withCtx(() => [
            _createVNode(ChunksPanel)
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "stats" }, {
          default: _withCtx(() => [
            _createVNode(StatsPanel)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})